import React, { useState } from "react";
import "./styles.less";
import { Header } from "../../components/Header";
import { Footer } from "../../components/FooterV2";
import { ManufacturingBanner } from "./components/ManufacturingBanner";
import { ManufacturingMarquee } from "./components/ManufacturingMarquee";

import { FinanceChart } from "./components/ManufacturingChart";
import { ManufacturingQuestion } from "./components/ManufacturingQuestion";
import { ManufacturingAdvantage } from "./components/ManufacturingAdvantage";
import { ManufacturingProductivity } from "./components/ManufacturingProductivity";

import { HomeTryOn } from "../../blocks/home-try-on";

export const Car = (props) => {
  return (
    <div className="manufacturing">
      <Header mode="light" special />
      <ManufacturingBanner />
      <ManufacturingMarquee />
      <ManufacturingQuestion />
      <ManufacturingAdvantage />
      <ManufacturingProductivity />
      <HomeTryOn hasBg />
      <Footer />
    </div>
  );
};
